import {
  AtribuirConsultorDto,
  MovimentacaoCardsDto
} from 'controller/kanbanController'
import {
  KANBAN,
  TYPES,
  CardKanban,
  SelectChatwoot,
  MensagemChatwootDto
} from './types'

export const setKanban = (value: KANBAN['kanbanData']) => ({
  type: TYPES.SET_KANBAN,
  value
})

export const setLoadingKanban = (value: KANBAN['loadingKanban']) => ({
  type: TYPES.SET_LOADING_KANBAN,
  value
})

export const getKanbanSaga = () => ({
  type: TYPES.GET_KANBAN_SAGA
})

export const getCentrosCustoSaga = () => ({
  type: TYPES.GET_CENTROS_CUSTO_SAGA
})

export const getPipelinesSaga = (id?: string, buscaPipelineDefault = true) => ({
  type: TYPES.GET_PIPELINES_SAGA,
  id,
  buscaPipelineDefault
})

type FieldOptionsSelect = keyof KANBAN['optionsSelect']
export const setOptionsSelect = <T extends FieldOptionsSelect>(
  value: KANBAN['optionsSelect'][T],
  field: T
) => ({
  type: TYPES.SET_OPTIONS_SELECT,
  value,
  field
})

type FieldLoadingOptionsSelect = keyof KANBAN['loadingSelect']
export const setLoadingSelect = <T extends FieldLoadingOptionsSelect>(
  value: KANBAN['loadingSelect'][T],
  field: T
) => ({
  type: TYPES.SET_LOADING_SELECT,
  value,
  field
})

type FieldFiltros = keyof KANBAN['filtros']
export const setFiltrosField = <T extends FieldFiltros>(
  value: KANBAN['filtros'][T],
  field: T
) => ({
  type: TYPES.SET_FILTROS_FIELD,
  value,
  field
})

export const movimentarCardKanbanSaga = (value: MovimentacaoCardsDto) => ({
  type: TYPES.MOVIMENTAR_CARD_KANBAN_SAGA,
  value
})

export const verificarMotivoMovimentacaoSaga = (value: {
  card: CardKanban
  from: { fromPosition: number; fromColumnId: string }
  to: { toPosition: number; toColumnId: string }
}) => ({
  type: TYPES.VERIFICAR_MOTIVO_MOVIMENTACAO_SAGA,
  value
})

export const executarMovimentacaoComMotivoSaga = () => ({
  type: TYPES.EXECUTAR_MOVIMENTACAO_COM_MOTIVO_SAGA
})

export const setMovimentacaoPendente = (
  value: KANBAN['movimentacaoPendente']
) => ({
  type: TYPES.SET_MOVIMENTACAO_PENDENTE,
  value
})

export const setIsOpenModalMotivo = (value: boolean) => ({
  type: TYPES.SET_IS_OPEN_MODAL_MOTIVO,
  value
})

export const setMotivoMovimentacao = (value: KANBAN['motivoMovimentacao']) => ({
  type: TYPES.SET_MOTIVO_MOVIMENTACAO,
  value
})

export const cleanMotivoMovimentacao = () => ({
  type: TYPES.CLEAN_MOTIVO_MOVIMENTACAO
})

export const criarMotivoMovimentacaoSaga = () => ({
  type: TYPES.CRIAR_MOTIVO_MOVIMENTACAO_SAGA
})

export const getMotivosPerdaSaga = () => ({
  type: TYPES.GET_MOTIVOS_PERDA_SAGA
})

export const setIsOpenModalAgendamento = (value: boolean) => ({
  type: TYPES.SET_IS_OPEN_MODAL_AGENDAMENTO,
  value
})

export const setAgendamento = (value: KANBAN['agendamento']) => ({
  type: TYPES.SET_AGENDAMENTO,
  value
})

export const cleanAgendamento = () => ({
  type: TYPES.CLEAN_AGENDAMENTO
})

export const getTiposAgendamentoSaga = () => ({
  type: TYPES.GET_TIPOS_AGENDAMENTO_SAGA
})

export const criarAgendamentoSaga = () => ({
  type: TYPES.CRIAR_AGENDAMENTO_SAGA
})

export const getInformacoesCardKanbanSaga = (id: string) => ({
  type: TYPES.GET_INFORMACOES_CARD_KANBAN_SAGA,
  id
})

export const setIsOpenModalKanban = (value: boolean) => ({
  type: TYPES.SET_IS_OPEN_MODAL_KANBAN,
  value
})

export const setInformacoesModalKanban = (
  value: KANBAN['modalKanban']['informacoes']
) => ({
  type: TYPES.SET_INFORMACOES_MODAL_KANBAN,
  value
})

export const atribuirConsultorCardKanbanSaga = (
  value: AtribuirConsultorDto
) => ({
  type: TYPES.ATRIBUIR_CONSULTOR_CARD_KANBAN_SAGA,
  value
})

export const getConsultoresModalKanbanSaga = (id: string) => ({
  type: TYPES.GET_CONSULTORES_MODAL_KANBAN_SAGA,
  id
})

export const setConsultorModalKanban = (
  value: KANBAN['modalKanban']['consultor']
) => ({
  type: TYPES.SET_CONSULTOR_MODAL_KANBAN,
  value
})

export const setConsultoresModalKanban = (
  value: KANBAN['modalKanban']['consultores']
) => ({
  type: TYPES.SET_CONSULTORES_MODAL_KANBAN,
  value
})

export const setInformacoesCardKanbanField = <
  T extends keyof KANBAN['modalKanban']['informacoes']
>(
  value: KANBAN['modalKanban']['informacoes'][T],
  field: T
) => ({
  type: TYPES.SET_INFORMACOES_CARD_KANBAN_FIELD,
  value,
  field
})

export const criarAnotacaoCardKanbanSaga = (id: string) => ({
  type: TYPES.CRIAR_ANOTACAO_CARD_KANBAN_SAGA,
  id
})

export const setAnotacaoCardKanban = (value: string) => ({
  type: TYPES.SET_ANOTACAO_CARD_KANBAN,
  value
})

export const setBigNumbers = (value: KANBAN['bigNumbers']) => ({
  type: TYPES.SET_BIG_NUMBERS,
  value
})

export const getBigNumbersSaga = (id: string) => ({
  type: TYPES.GET_BIG_NUMBERS_SAGA,
  id
})

export const setIsOpenModalCadastroCliente = (value: boolean) => ({
  type: TYPES.SET_IS_OPEN_MODAL_CADASTRO_CLIENTE,
  value
})

export const setRegisterModalCadastroClienteField = <
  T extends keyof KANBAN['modalCadastroCliente']['register']
>(
  value: KANBAN['modalCadastroCliente']['register'][T],
  field: T
) => ({
  type: TYPES.SET_REGISTER_MODAL_CADASTRO_CLIENTE_FIELD,
  value,
  field
})

export const setRegisterModalCadastroCliente = (
  value: KANBAN['modalCadastroCliente']['register']
) => ({
  type: TYPES.SET_REGISTER_MODAL_CADASTRO_CLIENTE,
  value
})

export const cleanRegisterModalCadastroCliente = () => ({
  type: TYPES.CLEAN_REGISTER_MODAL_CADASTRO_CLIENTE
})

export const setIsOpenModalCpf = (value: boolean) => ({
  type: TYPES.SET_IS_OPEN_MODAL_CPF,
  value
})

export const setCpfModalCpf = (value: string) => ({
  type: TYPES.SET_CPF_MODAL_CPF,
  value
})

export const cadastrarClienteSaga = () => ({
  type: TYPES.CADASTRAR_CLIENTE_SAGA
})

export const adicionarClienteKanbanSaga = (cpf: string) => ({
  type: TYPES.ADICIONAR_CLIENTE_KANBAN_SAGA,
  cpf
})

export const getConveniosSaga = () => ({
  type: TYPES.GET_CONVENIOS_SAGA
})

export const getPerfisSaga = () => ({
  type: TYPES.GET_PERFIS_SAGA
})

export const setInvalidsRegisterModalCadastroClienteField = <
  T extends keyof KANBAN['modalCadastroCliente']['invalids']
>(
  value: KANBAN['modalCadastroCliente']['invalids'][T],
  field: T
) => ({
  type: TYPES.SET_INVALIDS_REGISTER_MODAL_CADASTRO_CLIENTE_FIELD,
  value,
  field
})

export const cleanInvalidsRegisterModalCadastroCliente = () => ({
  type: TYPES.CLEAN_INVALIDS_REGISTER_MODAL_CADASTRO_CLIENTE
})

export const setIsOpenModalConfirmacao = (value: boolean) => ({
  type: TYPES.SET_IS_OPEN_MODAL_CONFIRMACAO,
  value
})

export const setCoordenador = (value: boolean) => ({
  type: TYPES.SET_COORDENADOR,
  value
})

export const verificaHierarquiaEDisparaGetsSaga = () => ({
  type: TYPES.VERIFICA_HIERARQUIA_E_DISPARA_GETS_SAGA
})

export const getPipelineDefaultSaga = () => ({
  type: TYPES.GET_PIPELINE_DEFAULT_SAGA
})

export const toggleChatwootModal = (value: boolean) => ({
  type: TYPES.TOGGLE_CHATWOOT_MODAL,
  value
})

export const setInboxesChatWoot = (value: SelectChatwoot[]) => ({
  type: TYPES.SET_INBOXES_CHATWOOT,
  value
})

export const setAgentesChatWoot = (value: SelectChatwoot[]) => ({
  type: TYPES.SET_AGENTES_CHATWOOT,
  value
})

export const setAgenteChatwootSelected = (value: string | null) => ({
  type: TYPES.SET_AGENTE_CHATWOOT_SELECTED,
  value
})

export const setInboxChatwootSelected = (value: string | null) => ({
  type: TYPES.SET_INBOX_CHATWOOT_SELECTED,
  value
})

export const getInboxesChatwootSaga = () => ({
  type: TYPES.GET_INBOXES_CHATWOOT_SAGA
})

export const getAgentesChatwootSaga = () => ({
  type: TYPES.GET_AGENTES_CHATWOOT_SAGA
})

export const enviarMensagemChatwootSaga = (value: MensagemChatwootDto) => ({
  type: TYPES.ENVIAR_MENSAGEM_CHATWOOT_SAGA,
  value
})

export const cleanModalChatwoot = () => ({
  type: TYPES.CLEAN_MODAL_CHATWOOT
})

export const getAgenteSelecionadoChatWootSaga = () => ({
  type: TYPES.GET_AGENTE_SELECIONADO_CHATWOOT_SAGA
})

export const initializeWebSocketsChannelRetornoKanbanSaga = () => ({
  type: TYPES.INITIALIZE_WEB_SOCKETS_CHANNEL_RETORNO_KANBAN_SAGA
})

export const disconnectWebSocketsChannelRetornoKanbanSaga = () => ({
  type: TYPES.DISCONNECT_WEB_SOCKETS_CHANNEL_RETORNO_KANBAN_SAGA
})

export const atualizarInscricaoPipelineKanbanSaga = (
  pipelineId: string,
  pipelineIdAnterior: string | null
) => ({
  type: TYPES.ATUALIZAR_INSCRICAO_PIPELINE_KANBAN_SAGA,
  payload: { pipelineId, pipelineIdAnterior }
})

export const setModalDiscagem = (value: KANBAN['discagem']) => ({
  type: TYPES.SET_MODAL_DISCAGEM,
  value
})

export const cleanModalDiscagem = () => ({
  type: TYPES.CLEAN_MODAL_DISCAGEM
})

export const discarClienteKanbanSaga = (value: {
  pipelineEtapaClienteId: string
  telefoneId: string
  numero: string
  cpf: string
}) => ({
  type: TYPES.DISCAR_CLIENTE_KANBAN_SAGA,
  value
})

export const setGravacao = (callId: string, url: string) => ({
  type: TYPES.SET_GRAVACAO,
  callId,
  url
})

export const buscarGravacaoSaga = (callId: string) => ({
  type: TYPES.BUSCAR_GRAVACAO_SAGA,
  callId
})
